import RouterView from '@/components/pages/RouterView/Router'
import Questionnaire from '@/components/pages/Questionnaire/Questionnaire'

export default {
  path: '/patient',
  component: RouterView,
  meta: {requiresAuth: false},
  children: [
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: 'questionnaire/:questionnaireId',
          component: Questionnaire,
          props: true,
          name: 'patient-questionnaire-unauth'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/questionnaire.js